import { Box, Grid } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext } from "react";

import { isPage } from "utils/general";
import { trackEvent } from "utils/tracking";

import { Page } from "../TopNavigation/schema";
import LeftSideBarIcon from "./Icon";
import styles from "./styles";

function LeftSidebar() {
  const trackPageNavigation = (route: string) => {
    trackEvent("Page Navigated", { route });
  };

  const { currentOrg } = useContext(OrganizationUserContext);
  return (
    <Box sx={styles.root}>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        flexDirection="column"
        sx={{ height: "100vh" }}
      >
        <Grid
          item
          container
          alignItems="center"
          justifyContent="space-between"
          flexDirection="column"
          gap={2}
          sx={{ mt: 2 }}
        >
          {!currentOrg?.isBrand && (
            <LeftSideBarIcon
              name="Home"
              icon="fa-regular fa-home"
              activeIcon="fa-solid fa-home"
              isActive={isPage(Page.HOME)}
              link={`/dashboard/${Page.HOME}`}
              onClick={() => trackPageNavigation(Page.HOME)}
            />
          )}
          {!currentOrg?.isBrand && (
            <LeftSideBarIcon
              name="Brands"
              icon="fa-regular fa-search"
              activeIcon="fa-solid fa-search"
              isActive={isPage(Page.BRANDS)}
              link={`/dashboard/${Page.BRANDS}`}
              onClick={() => trackPageNavigation(Page.BRANDS)}
            />
          )}
          {!currentOrg?.isBrand && (
            <LeftSideBarIcon
              name="Recos"
              icon="fa-regular fa-star"
              activeIcon="fa-solid fa-star"
              isActive={isPage(Page.RECOMMENDATIONS)}
              link={`/dashboard/${Page.RECOMMENDATIONS}`}
              onClick={() => trackPageNavigation(Page.RECOMMENDATIONS)}
            />
          )}
          <LeftSideBarIcon
            name="Inbox"
            icon="fa-regular fa-envelope"
            activeIcon="fa-solid fa-envelope"
            isActive={isPage(Page.INBOX)}
            link={`/dashboard/${Page.INBOX}`}
            onClick={() => trackPageNavigation(Page.INBOX)}
          />
          <LeftSideBarIcon
            name="Tracking"
            icon="fa-regular fa-square-kanban"
            activeIcon="fa-solid fa-square-kanban"
            isActive={isPage(Page.TRACKING)}
            link={`/dashboard/${Page.TRACKING}`}
            onClick={() => trackPageNavigation(Page.TRACKING)}
          />
          <LeftSideBarIcon
            name="Campaigns"
            icon="fa-regular fa-chart-simple-horizontal"
            activeIcon="fa-solid fa-chart-simple-horizontal"
            isActive={isPage(Page.CAMPAIGNS)}
            link={`/dashboard/${Page.CAMPAIGNS}`}
            onClick={() => trackPageNavigation(Page.CAMPAIGNS)}
          />
          {!currentOrg?.isBrand && (
            <LeftSideBarIcon
              name="Local"
              icon="fa-regular fa-location-dot"
              activeIcon="fa-solid fa-location-dot"
              isActive={isPage(Page.LOCAL)}
              link={`/dashboard/${Page.LOCAL}`}
              onClick={() => trackPageNavigation(Page.LOCAL)}
            />
          )}
          {currentOrg?.isVaUser && !currentOrg?.isBrand && (
            <LeftSideBarIcon
              name="VA"
              icon="fa-regular fa-bolt"
              activeIcon="fa-solid fa-bolt"
              isActive={isPage(Page.VA)}
              link={`/dashboard/${Page.VA}`}
              onClick={() => trackPageNavigation(Page.VA)}
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
}

export default LeftSidebar;
